import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, message } from 'antd-v5';
import { getRequest } from '../../../../../core/apiRequests';
import OpportunityModal from '.';

// Link-styled trigger that opens the read-only Opportunity Details modal used by the Sales Opp report
const OpportunityDetailsLink = ({ salesOppId, children }) => {
  const merchantId = useSelector(state => state.auth.merchantId);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [salesOpportunityHistory, setSalesOpportunityHistory] = useState(null);

  const handleClick = useCallback(
    async e => {
      e.stopPropagation();
      setOpen(true);
      setLoading(true);
      try {
        const reqObj = {
          params: ['client', merchantId, salesOppId, 'getSalesOppHistory'],
          loadingStatusOff: true,
        };
        const response = await getRequest(reqObj);
        setSalesOpportunityHistory(response?.resultsOpp?.length ? response : null);
      } catch (error) {
        message.error('Error Fetching Sales Opportunity');
        setSalesOpportunityHistory(null);
      } finally {
        setLoading(false);
      }
    },
    [merchantId, salesOppId],
  );

  return (
    <>
      <Button type="link" className="opportunity-details-link" onClick={handleClick}>
        {children}
      </Button>
      {open && (
        <OpportunityModal
          open={open}
          onClose={() => setOpen(false)}
          loading={loading}
          salesOpportunityHistory={salesOpportunityHistory}
          showActivities={false}
        />
      )}
    </>
  );
};

export default OpportunityDetailsLink;
